import { render, staticRenderFns } from "./TaskNoCurrent.vue?vue&type=template&id=456360e5&scoped=true&"
import script from "./TaskNoCurrent.vue?vue&type=script&lang=ts&"
export * from "./TaskNoCurrent.vue?vue&type=script&lang=ts&"
import style0 from "./TaskNoCurrent.vue?vue&type=style&index=0&id=456360e5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456360e5",
  null
  
)

export default component.exports